import type { ScalarFilterType } from '@/shared/types/gsplat'

/**
 * 把公共标量过滤类型映射为 shader uniform 的整型编码。
 *
 * WebGL2 与 WebGPU 的 WorkBuffer source-copy pass 共用同一编码，确保两后端过滤语义一致。
 */
export function resolveScalarFilterMode(type: ScalarFilterType | undefined): number {
  switch (type) {
    case 'volume':
      return 1
    case 'surface-area':
      return 2
    case 'value':
      return 3
    default:
      return 0
  }
}
